import {
  ChakraFlex,
  ChakraGridItem,
  ChakraText,
  EquipUITheme,
  NumberInput,
} from '@equip.health/ui';

import { GridItemProps, PatientVitalsTabs } from '../../constants';

const { paragraphBold } = EquipUITheme.typography;

const ValueGridItem = <T extends string | number>({
  colSpan,
  id,
  isEditing,
  onChange,
  unit,
  tab,
  value,
}: GridItemProps<T> & { unit: string; onChange: (val: string) => void }) => (
  <ChakraGridItem colSpan={colSpan}>
    {unit && (
      <ChakraFlex align="center">
        {isEditing && (
          <NumberInput
            color="neutral.primary"
            height="32px"
            id={`${id}__value`}
            inputPadding="0px 12px"
            maxLength={
              tab === PatientVitalsTabs.WEIGHT ||
              tab === PatientVitalsTabs.HEIGHT
                ? 6
                : 3
            }
            min={0}
            onChange={(val) => {
              onChange(val);
            }}
            size="sm"
            value={value as unknown as number} // TODO - can this work as string-parsed number or it has to be string?
          />
        )}
        <ChakraText
          {...paragraphBold}
          id={`${id}__value-display`}
          lineHeight="120%"
        >
          {isEditing ? '' : value}&nbsp;{unit}
        </ChakraText>
      </ChakraFlex>
    )}
  </ChakraGridItem>
);

export default ValueGridItem;
